/**
 * The pattern of valid slugs.
 */
export const validSlugPattern: RegExp = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export default validSlugPattern;
